namespace $.$$ {

	export class $shm_tree extends $.$shm_tree {

		visible_ids() {
			const ids = [] as any[]
			const visit = ( id: any )=> {
				ids.push( id )
				if( !this.expanded( id ) ) return
				for( const child of this.children( id ) ) visit( child )
			}
			for( const root of this.roots() ) visit( root )
			return ids
		}

		visible_rows() {
			return this.visible_ids().map( id => this.Row( id ) )
		}

		parent( id: any ) {
			const find = ( parent: any ): any => {
				for( const child of this.children( parent ) ) {
					if( child === id ) return parent
					const found = find( child )
					if( found !== undefined ) return found
				}
				return undefined
			}
			for( const root of this.roots() ) {
				if( root === id ) return undefined
				const found = find( root )
				if( found !== undefined ) return found
			}
			return undefined
		}

		ancestors( id: any ) {
			const ancestors = [] as any[]
			for( let parent = this.parent( id ); parent !== undefined; parent = this.parent( parent ) ) ancestors.unshift( parent )
			return ancestors
		}

		row_depth( id: any ) {
			return this.ancestors( id ).length
		}

		content_left( id: any ) {
			return `${ ( this.row_depth( id ) + 1 ) * this.indent() }px`
		}

		toggle_left( id: any ) {
			return `${ this.row_depth( id ) * this.indent() + this.indent() / 2 - 4 }px`
		}

		toggle_visibility( id: any ) {
			return this.children( id ).length ? 'visible' : 'hidden'
		}

		has_next_sibling( id: any ) {
			const parent = this.parent( id )
			const siblings = parent === undefined ? this.roots() : this.children( parent )
			return siblings.indexOf( id ) < siblings.length - 1
		}

		guide_rows( id: any ) {
			const ancestors = this.ancestors( id )
			const depth = ancestors.length
			const keys = [] as string[]
			for( let level = 0; level < depth; ++level ) {
				const branch = level === depth - 1 ? id : ancestors[ level + 1 ]
				if( level === depth - 1 || this.has_next_sibling( branch ) ) {
					keys.push( `${ id }|${ level }|vertical|${ this.has_next_sibling( branch ) ? 0 : 1 }` )
				}
			}
			if( depth ) keys.push( `${ id }|${ depth - 1 }|horizontal|0` )
			return keys.map( key => this.Guide( key ) )
		}

		guide_parts( key: string ) {
			const [ , level, orientation, last ] = key.split( '|' )
			return { level: Number( level ), orientation, last: last === '1' }
		}

		@ $mol_mem_key
		override Guide( key: string ) {
			const view = super.Guide( key )
			view.style = (): { [ key: string ]: string | number }=> {
				const part = this.guide_parts( key )
				const left = ( part.level + 1 ) * this.indent()
				return part.orientation === 'horizontal'
					? { left, top: '50%', width: this.indent(), height: 1 }
					: { left, top: 0, bottom: part.last ? '50%' : 0, width: 1 }
			}
			return view
		}

		@ $mol_mem_key
		override Toggle( id: any ) {
			const toggle = super.Toggle( id )
			const style = toggle.style.bind( toggle )
			toggle.style = ()=> ({ ... style(), visibility: this.toggle_visibility( id ) })
			return toggle
		}

	}

}
